import { render, staticRenderFns } from "./SelfOrder.vue?vue&type=template&id=4ae7e94e"
import script from "./SelfOrder.vue?vue&type=script&lang=js"
export * from "./SelfOrder.vue?vue&type=script&lang=js"
import style0 from "./SelfOrder.vue?vue&type=style&index=0&id=4ae7e94e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports